/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { useConfigurationStore } from '@/stores/configurationModule';
import { useConfiguratorStore } from '@/stores/configurator';
import { useKeyboardStore } from '@/stores/keyboard';
export default function useWorkspaceEventListeners() {
  // ------------------------------------------------
  const keyboardStore = useKeyboardStore();
  const {
    isSpacebarDown
  } = storeToRefs(keyboardStore);
  const configurationStore = useConfigurationStore();
  const {
    setActivePanel,
    discardActiveObjects
  } = configurationStore;
  const configuratorStore = useConfiguratorStore();
  const {
    canvasContainerScale,
    minVisibleFraction
  } = storeToRefs(configuratorStore);
  const workspace = document.querySelector('#workspace');
  const canvasContainer = document.querySelector('.canvas-container');
  const canvasAndOverlayContainer = document.querySelector('.canvas-and-overlay-container');
  const canvasSpacers = Array.from(document.querySelectorAll('.canvasSpacer'));
  const sideLabelTexts = Array.from(document.querySelectorAll('.side-label--text'));
  let isPanning = ref(false);
  let startMouseX = 0;
  let startMouseY = 0;
  let startCanvasLeft = 0;
  let startCanvasTop = 0;
  const PANNING_SENSITIVITY = 1.1;

  // PANNING
  // ============================================================
  // Helper function to get touch position

  // Handlers for starting, moving, and ending the interaction
  const handleStart = (pageX, pageY, target) => {
    if (target === canvasContainer || target === workspace || target === canvasAndOverlayContainer || canvasSpacers.includes(target) || sideLabelTexts.includes(target) || isSpacebarDown.value) {
      isPanning.value = true;
      startMouseX = pageX;
      startMouseY = pageY;
      startCanvasLeft = canvasContainer.offsetLeft;
      startCanvasTop = canvasContainer.offsetTop;
      workspace.style.cursor = 'grabbing';
      discardActiveObjects();

      // Deselect panel
      // @NOTE: Revisit this
      if (!target.classList.contains('panel-overlay') && !isSpacebarDown.value) {
        setActivePanel();
      }
    }
  };
  const handleEnd = () => {
    isPanning.value = false;
    workspace.style.cursor = 'grab';
  };
  function calculateContainerX(mousePosition) {
    const containerSize = canvasContainer.offsetWidth;
    const workspaceSize = workspace.offsetWidth;
    const scaledSize = containerSize * canvasContainerScale.value;
    const visible = workspaceSize * minVisibleFraction.value;
    const delta = (mousePosition - startMouseX) * PANNING_SENSITIVITY;
    let position = startCanvasLeft + delta;
    const offset = (containerSize - scaledSize) / 2;
    if (position > workspaceSize - offset - visible) {
      position = workspaceSize - offset - visible;
    }
    if (position < -(scaledSize + offset) + visible) {
      position = -(scaledSize + offset) + visible;
    }
    return position;
  }
  function calculateContainerY(mousePosition) {
    const containerSize = canvasContainer.offsetHeight;
    const workspaceSize = workspace.offsetHeight;
    const scaledSize = containerSize * canvasContainerScale.value;
    const visible = workspaceSize * minVisibleFraction.value;
    const delta = (mousePosition - startMouseY) * PANNING_SENSITIVITY;
    let position = startCanvasTop + delta;
    const offset = (containerSize - scaledSize) / 2;
    if (position > workspaceSize - offset - visible) {
      position = workspaceSize - offset - visible;
    }
    if (position < -(scaledSize + offset) + visible) {
      position = -(scaledSize + offset) + visible;
    }
    return position;
  }
  const setCanvasContainerPosition = (pageX, pageY) => {
    const canvasContainerLeft = calculateContainerX(pageX);
    const canvasContainerTop = calculateContainerY(pageY);
    canvasContainer.style.left = canvasContainerLeft + 'px';
    canvasContainer.style.top = canvasContainerTop + 'px';
  };
  const handleMove = (pageX, pageY) => {
    if (isPanning.value) {
      setCanvasContainerPosition(pageX, pageY);
    }
  };
  const getTouchPos = e => {
    const touch = e.touches[0] || e.changedTouches[0];
    return {
      pageX: touch.pageX,
      pageY: touch.pageY
    };
  };

  // Workspace event listeners for mouse events
  workspace.addEventListener('mousedown', e => {
    handleStart(e.pageX, e.pageY, e.target);
  });
  workspace.addEventListener('mousemove', e => {
    handleMove(e.pageX, e.pageY);
  });
  workspace.addEventListener('mouseup', handleEnd);
  workspace.addEventListener('mouseleave', handleEnd);
  workspace.addEventListener('mouseenter', () => {
    workspace.style.cursor = 'grab';
  });

  // Workspace event listeners for touch events
  workspace.addEventListener('touchstart', e => {
    const {
      pageX,
      pageY
    } = getTouchPos(e);
    handleStart(pageX, pageY, e.target);
    e.preventDefault();
  });
  workspace.addEventListener('touchmove', e => {
    const {
      pageX,
      pageY
    } = getTouchPos(e);
    handleMove(pageX, pageY);
    e.preventDefault();
  });
  workspace.addEventListener('touchend', handleEnd);
  workspace.addEventListener('touchcancel', handleEnd);
}